import { render, staticRenderFns } from "./FamousCommentEditPanel.vue?vue&type=template&id=e4f06774&"
import script from "./FamousCommentEditPanel.vue?vue&type=script&lang=js&"
export * from "./FamousCommentEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports